import client from 'client';
import { useQuery } from 'react-query';

export async function fetchAppExtension<IAppExtensionItem>(extensionId: string) {
    return (await client().get<IAppExtensionItem>(`/api/v2/developer/extensions/${extensionId}`))
        .data;
}

const useAppExtension = <IAppExtensionItem>(extensionId?: string) => {
    return useQuery<IAppExtensionItem, Error>(
        ['extensionId', extensionId],
        () => fetchAppExtension(extensionId),
        {
            staleTime: Infinity,
            retry: 3,
            enabled: !!extensionId,
        }
    );
};

export default useAppExtension;
